export const SHIPMENT_FLOW_TYPE = {
  FIRST_SHIPMENT: "FIRST_SHIPMENT",
  RENEW_SHIPMENT: "RENEW_SHIPMENT",
} as const;

export type ShipmentFlowType =
  (typeof SHIPMENT_FLOW_TYPE)[keyof typeof SHIPMENT_FLOW_TYPE];
